import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sessao-seunegocio',
  templateUrl: './sessao-seunegocio.component.html',
  styleUrls: ['./sessao-seunegocio.component.scss']
})
export class SessaoSeunegocioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
